import { Table } from "antd";
import DefinitionsData from '../../data/definitionsData.json'
import { getCarrierByDomain } from "../../domain";

const GlossaryReport = ({ onClose, selectedTab, projectName, theme }) => {

    //const data = DefinitionsData['GlossaryDataCVM']

    let tableColumns = [
        {
          title: "Terms",
          dataIndex: "report/metric",
          key: "report/metric",
          width: 220,
          className: "!rounded-none",
        },
        {
          title: 'Definition',
          dataIndex: 'definition',
          key: 'definition',
          width: 220
        },
    ];

    const dynamicStyle = {
    '--th-header': theme?.colors?.textWhiteColor,
    }
    const html1=()=> {
        return <div dangerouslySetInnerHTML={{__html: "Number of new subscriptions taking up an Asurion product whose start effective date is within the concerned period <br/> Excludes:<br/><br/><ul class='list-disc ml-8'><li>Renewal<br/> </li> <li>New enrollments that also churn on the same day (aka. same-day churn/cancellation) where the subscriber is not financially liable for the cancellation</li></ul>"}} />;
    }
    const html2=()=> {
        return <div dangerouslySetInnerHTML={{__html: "Number of subscriptions that are renewed/extended or migrated to another product without a break in coverage in the concerned period <br/>Includes:<br/><br/><ul class='list-disc ml-8'><li>Subscribers who continue to subscribe to same Asurion DP product when entering a new phone contract with the carrier</li></ul>"}} />;
    }
    const html3=()=> {
        return <div dangerouslySetInnerHTML={{__html: "Number of subscriptions canceled or terminated and whose end effective date is within the concerned period and the subscriber doesn't renew/extend or enroll to another Asurion product offered by the same carrier <br/> Exclusion:<br/><br/><ul class='list-disc ml-8'><li> Renewal</li></ul>"}} />;
    }
    let data= [
        {
            "report/metric": "Gross Add",
            "definition": html1 ()
        },
        {
            "report/metric": "Renewal",
            "definition": html2()
        },
        {
            "report/metric": "Churn",
            "definition": html3()
        },
        {
            "report/metric": "Remorse Churn",
            "definition": "Number of subscriptions canceled or terminated and whose end effective date is within the first 90 days of enrollment and the subscriber doesn't renew/extend or enroll to another Asurion product offered by the same carrier"
        },
        {
            "report/metric": "Mid Contract Churn",
            "definition": "Number of subscriptions canceled or terminated and whose end effective date is between 4th and 23th month and the subscriber doesn't renew/extend or enroll to another Asurion product offered by the same carrier"
        },
        {
            "report/metric": "Upgrade Churn",
            "definition": "Number of subscriptions canceled or terminated and whose end effective date is 24th month and above and the subscriber doesn't renew/extend or enroll to another Asurion product offered by the same carrier"
        },
        {
            "report/metric": "Net Add",
            "definition": "Number of new subscriptions which are active throughout the concerned period"
        },
        {
            "report/metric": "Churn Rate",
            "definition": "A monthly rate to show how much in percentage term the subscriptions in current customer base will like to churn in next 12 month time based on the average rate of churn within an interested report period"
        },
        {
            "report/metric": "Closing Subscriber",
            "definition": "Number of active subscriptions at the end of the concerned period, ie. when it turns 00:00 AM of the next day of the end of the period. Therefore, customers who churn on the last day of the period is excluded"
        }
    ];
    
    return (
        <div className={`bg-app-lightWhite w-full mx-auto rounded-xl`}>
          {/* ${(projectName === "Technical Service SLA Report" && selectedTab === "Glossary") ? 'w-3/4' : 'w-3/5'} */}
                <Table
                    columns={ tableColumns}
                    dataSource={data}
                    style={dynamicStyle}
                    rowKey="data"
                    key="data"
                    pagination={false}
                    className="table-css border-current border-white hz-scrollbar pb-2 mt-5"
                    // scroll={{
                    //     y: "80vh",
                    // }}
                />
        </div>
    );
};

export default GlossaryReport;
